@if (!isFinished()) {
    <div class="container pt-3 fade-in-left" id="centerFrame">
        <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
            <a (click)="back()">
                <div class="p-2">
                    <i class="bi bi-chevron-left align-middle"></i>
                </div>
            </a>
            <div class="p-2 flex-grow-1 pl-2">
                <h1 class="text-dark text-center">Resumen de tu solicitud</h1>
            </div>
            <div class="p-2 pl-2 help" (click)="openhelp()">
                <i class="bi bi-info-circle"></i>
            </div>
        </div>

        @if (helpOpen()) {
            <div class="row m-3 p-3 align-items-center tooltip-pwa tooltip-pwa--open" id="tooltip-pwa" style="display:flex;">
                <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
                <div class="col">{{ helpText() }}</div>
                <div class="col-auto" (click)="openhelp()">
                    <i class="bi bi-x-lg" style="font-size: 1.4em;"></i>
                </div>
            </div>
        }

        <div class="resumen-wrap">
            <div class="summary-card fade-in">
                <div class="summary-header">
                    <div class="summary-avatar">
                        @if (avatarPrestadorUrl) {
                            <img [src]="avatarPrestadorUrl" alt="" class="summary-avatar-img" />
                        } @else {
                            <i class="bi" [ngClass]="iconoResumen"></i>
                        }
                    </div>
                    <div class="summary-header-text">
                        <div class="summary-title">{{ tituloResumen }}</div>
                        @for (sub of subtitulosResumen; track sub) {
                            <div class="summary-subtitle">{{ sub }}</div>
                        }
                    </div>
                </div>

                <hr class="divisor mt-3 mb-1">

                <div class="summary-row">
                    <i class="bi bi-calendar2-check summary-icon"></i>
                    <div class="summary-row-content">
                        <div class="summary-row-label">Fechas posibles</div>
                        <div class="summary-chips">
                            @if (d_fecha_uno) { <span class="chip">{{ d_fecha_uno | date:'dd/MM/yyyy' }}</span> }
                            @if (d_fecha_dos) { <span class="chip">{{ d_fecha_dos | date:'dd/MM/yyyy' }}</span> }
                            @if (d_fecha_tres) { <span class="chip">{{ d_fecha_tres | date:'dd/MM/yyyy' }}</span> }
                        </div>
                    </div>
                </div>

                <div class="summary-row">
                    <i class="bi bi-clock summary-icon"></i>
                    <div class="summary-row-content">
                        <div class="summary-row-label">Horario</div>
                        <div class="summary-row-value">
                            @if (b_manana) { Mañana }
                            @if (b_manana && b_tarde || b_manana && b_noche) { · }
                            @if (b_tarde) { Tarde }
                            @if (b_tarde && b_noche) { · }
                            @if (b_noche) { Noche }
                        </div>
                    </div>
                </div>

                @if (lugarDescripcion) {
                    <div class="summary-row">
                        <i class="bi bi-geo-alt summary-icon"></i>
                        <div class="summary-row-content">
                            <div class="summary-row-label">Lugar</div>
                            <div class="summary-row-value">{{ lugarDescripcion }}</div>
                        </div>
                    </div>
                } @else if (x_zona) {
                    <div class="summary-row">
                        <i class="bi bi-geo-alt summary-icon"></i>
                        <div class="summary-row-content">
                            <div class="summary-row-label">Zona</div>
                            <div class="summary-row-value">{{ x_zona }}</div>
                        </div>
                    </div>
                }
            </div>

            <div class="receta-card fade-in">
                <div class="receta-info">
                    <div class="receta-icon"><i class="bi bi-file-earmark-medical"></i></div>
                    <div class="receta-text">
                        <div class="receta-title">Receta</div>
                        <div class="receta-subtitle">En caso de tener una</div>
                    </div>
                </div>

                <div class="receta-action">
                    @if (preview_img_receta) {
                        <div class="edit-pencil fileupload rounded-pill pencil" (click)="capturarFileImgReceta()">
                            <i class="bi bi-pencil"></i>
                        </div>
                    }

                    <div class="row file btn btn-lg btn-primary fileupload rounded-pill m-0 btn-charge-credential">
                        @if (!preview_img_receta) {
                            <div class="btn file fileupload m-0 mt-0">
                                <div style="background-color: transparent;" (click)="capturarFileImgReceta()">
                                    <label>Cargar</label>
                                </div>
                            </div>
                        } @else {
                            <div>
                                <img
                                    width="100px"
                                    [src]="preview_img_receta"
                                    alt="Receta"
                                    class="receta"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalPreviewImgReceta"
                                />
                            </div>
                        }

                        <!-- input file queda por compatibilidad, pero tu captura usa Camera -->
                        <input
                            type="file"
                            class="form-control"
                            id="img_receta"
                            accept="image/*"
                            style="display: none;"
                            (change)="onFileSelected($event)"
                        />
                    </div>
                </div>
            </div>

            <!-- Modal Preview IMG RECETA :: INICIO -->
            <div
                class="modal fade"
                id="modalPreviewImgReceta"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modalPreviewImgRecetaLabel"
                aria-hidden="true"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="modalPreviewImgRecetaLabel">Receta</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <img [src]="preview_img_receta" class="img-fluid" />
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal Preview IMG RECETA :: FIN -->

            @if (error()) {
                <div class="alert alert-danger mt-2">
                    <small>{{ error() }}</small>
                </div>
            }

            <div class="d-grid mt-3 mb-2 pb-3">
                <button
                    class="btn btn-primary btn-lg mt-0"
                    (click)="finalizaOrder()"
                    [disabled]="loadingLocal()">
                    <i class="bi bi-send"></i> &nbsp;
                    {{ loadingLocal() ? 'Cargando...' : 'Enviar solicitud' }}
                </button>
            </div>
        </div>
    </div>
}
@if (isFinished()) {
    <div class="container mt-5 fade-in-left" id="centerFrameTwo">
        <div class="row p-3 mb-3 mt-5 align-items-center">
            <div class="mt-5">
                <div class="row form-switch ps-0 mb-3">
                    <div class="col text-center sucess-text mt-5 mb-5">
                        <b>
                            ¡Tu solicitud fue enviada<br>
                            <span class="bluetext">
                                <strong>a {{ n_cantidad_ordenes_enviadas() }} prestadores!</strong>
                            </span>
                        </b>
                    </div>
                </div>
            </div>
            <div class="d-grid mt-3 mb-3 pb-3">
                <button
                    class="btn btn-primary btn-lg mt-0"
                    [routerLink]="['/turnos']">
                    Volver
                </button>
            </div>
        </div>
    </div>
}
